import { render, staticRenderFns } from "./EnquirySub.vue?vue&type=template&id=21ea4cb2&scoped=true&"
import script from "./EnquirySub.vue?vue&type=script&lang=js&"
export * from "./EnquirySub.vue?vue&type=script&lang=js&"
import style0 from "./EnquirySub.vue?vue&type=style&index=0&id=21ea4cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ea4cb2",
  null
  
)

export default component.exports